import { DesignProp, LayoutProp } from "../PropCategories";

export const flexDirection = {
  prop: "style-attribute",
  name: "Flex Direction",
  nameI18n: "builder_ui.prop_type.styles.flex_direction",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "row",
  options: [
    {
      label: "Row",
      labelI18n: "builder_ui.prop_type.styles.flex_direction_types.row",
      value: "row",
    },
    {
      label: "Column",
      labelI18n: "builder_ui.prop_type.styles.flex_direction_types.column",
      value: "column",
    },
    {
      label: "Row Reverse",
      labelI18n: "builder_ui.prop_type.styles.flex_direction_types.row_reverse",
      value: "row-reverse",
    },
    {
      label: "Column Reverse",
      labelI18n:
        "builder_ui.prop_type.styles.flex_direction_types.column_reverse",
      value: "column-reverse",
    },
  ],
} as const;
